import { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { settingsService, type PublicSettings } from '../services/settings.service';
import { Loader2, Briefcase, Users } from 'lucide-react';

export default function HowItWorks() {
  const [settings, setSettings] = useState<PublicSettings>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const data = await settingsService.getPublicSettings();
        setSettings(data || {});
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main>
        <section className="py-16 bg-white border-b">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-gray-900 mb-3">Como Funciona</h1>
              <p className="text-gray-600">Entenda como usar o portal — empresas e candidatos</p>
            </div>
          </div>
        </section>

        <section className="py-12">
          <div className="container mx-auto px-4">
            <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-white border rounded-lg p-6 md:p-8">
                <div className="flex items-center gap-3 mb-4">
                  <div className="bg-brand-50 text-brand-800 rounded-lg p-3"><Briefcase className="w-6 h-6" /></div>
                  <h2 className="text-gray-900">Para Empresas</h2>
                </div>
                {loading ? (
                  <div className="text-center py-12">
                    <Loader2 className="size-8 animate-spin text-brand-600 mx-auto mb-3" />
                    <p className="text-gray-600">Carregando conteúdo...</p>
                  </div>
                ) : settings.how_it_works_companies ? (
                  <div className="prose max-w-none whitespace-pre-wrap leading-relaxed text-gray-800">
                    {settings.how_it_works_companies}
                  </div>
                ) : (
                  <p className="text-gray-600">Conteúdo não disponível ainda.</p>
                )}
              </div>

              <div className="bg-white border rounded-lg p-6 md:p-8">
                <div className="flex items-center gap-3 mb-4">
                  <div className="bg-brand-50 text-brand-800 rounded-lg p-3"><Users className="w-6 h-6" /></div>
                  <h2 className="text-gray-900">Para Candidatos</h2>
                </div>
                {loading ? (
                  <div className="text-center py-12">
                    <Loader2 className="size-8 animate-spin text-brand-600 mx-auto mb-3" />
                    <p className="text-gray-600">Carregando conteúdo...</p>
                  </div>
                ) : settings.how_it_works_candidates ? (
                  <div className="prose max-w-none whitespace-pre-wrap leading-relaxed text-gray-800">
                    {settings.how_it_works_candidates}
                  </div>
                ) : (
                  <p className="text-gray-600">Conteúdo não disponível ainda.</p>
                )}
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

